module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/fsboLogoDesktop.a0d88e9b.svg";